// ══════════════════════════════════════════════════════════════
// COMPASS – Process Risk Results Codes
// ══════════════════════════════════════════════════════════════

/** Risk results set by hand refused because the process is REJECTED (US-010; COMPLETED no longer, US-002): its status changed under
 *  the open page. */
export const RISK_RESULTS_LOCKED = 'error.kyc.risk-matrix.results-locked';

/** A reassessment date set by hand before the assessment: the results form shows it at the date, not as a toast
 *  (US-011). */
export const RISK_RESULTS_DATE_BEFORE_ASSESSMENT = 'error.kyc.risk-matrix.reassessment-date-before-assessment';

/** A removal of the results set by hand refused because there are none (US-021): the page is stale (another officer
 *  removed them, or an assessment replaced them), so the risk matrix is read again (US-030). */
export const RISK_RESULTS_NOT_EDITED = 'error.kyc.risk-matrix.results-not-edited';

/** The justification's maximum length, counted on the text as typed (the backend's @Size, before it strips it). */
export const RISK_JUSTIFICATION_MAX_LENGTH = 1000;
